/**
 * Idempotency-Key の払い出し（03 3.4.4・FE-D-029・030）。
 * 同じ操作のやり直しには同じ値を使う：送る内容のハッシュ（本文の JSON を並べ替えて SHA-256）と値の組を覚え、
 * 成功するまでは同じ内容で押し直したときに同じ値を返す。内容を変えたら新しい値。成功したら捨てる。
 */
import { issueSystemCode } from '@pcrm/shared';

function deepSort(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(deepSort);
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.keys(value as Record<string, unknown>)
        .sort()
        .map((key) => [key, deepSort((value as Record<string, unknown>)[key])]),
    );
  }
  return value;
}

export async function payloadHash(body: unknown): Promise<string> {
  const bytes = new TextEncoder().encode(JSON.stringify(deepSort(body ?? {})));
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

/** 1 つのフォーム（操作）ごとに 1 つ作る。キーの値は UUID v7 */
export class IdempotencyKeyHolder {
  private current: { hash: string; key: string } | null = null;

  async keyFor(body: unknown): Promise<string> {
    const hash = await payloadHash(body);
    if (this.current?.hash !== hash) {
      this.current = { hash, key: issueSystemCode() };
    }
    return this.current.key;
  }

  /** 成功したら捨てる */
  reset(): void {
    this.current = null;
  }
}
